import classNames from 'classnames';
import React from 'react';
import { Button } from 'reactstrap';
import styles from './styles.module.scss';
import { FileError } from 'use-file-picker';
import { LoadingSpinnerIcon } from '../../../LoadingSpinnerIcon';

export interface PropTypes {
  allowedFormats: string[];
  disabled?: boolean;
  isRequired?: boolean;
  isLoading?: boolean;
  errors?: FileError[];
  openFileSelector: () => void;
}

function placeholder(allowedFormats: string[], isLoading?: boolean) {
  if (isLoading) {
    return 'Checking files integrity...';
  }

  if (allowedFormats?.length === 1) {
    return `Choose files (${allowedFormats.join(',')})`;
  }

  return 'Choose files';
}

function InputBody(props: PropTypes) {
  const disabled = props.disabled || props.isLoading;

  return (
    <span
      className={classNames(
        'd-flex form-control fs-5 justify-content-between flex-nowrap',
        styles.placeholder,
        disabled ? 'bg-gray' : 'bg-white',
        { 'is-invalid': props.errors?.length > 0 },
      )}
    >
      {props.isLoading ? (
        <input
          type='text'
          className={classNames(
            'w-100',
            'no-border',
            styles['placeholder-input'],
            'bg-gray',
          )}
          readOnly
          placeholder={placeholder(props.allowedFormats, props.isLoading)}
          disabled={true}
        />
      ) : (
        <input
          type='text'
          className={classNames(
            'w-100',
            'no-border',
            { 'cursor-pointer': !disabled },
            styles['placeholder-input'],
            { 'bg-gray': disabled },
          )}
          onClick={() => props.openFileSelector()}
          readOnly
          placeholder={placeholder(props.allowedFormats, props.isLoading)}
          disabled={disabled}
        />
      )}
      {props.isLoading && (
        <LoadingSpinnerIcon className='text-info my-auto' size='md' />
      )}
    </span>
  );
}

export function AttachmentInputBody(props: PropTypes) {
  const isLoading = props.isLoading ?? false;

  return (
    <div className='input-group'>
      <input type='hidden' disabled={props.disabled || isLoading} />
      <InputBody {...props} isLoading={isLoading} />
      {!isLoading && (
        <Button
          size='md'
          className={classNames(
            styles['browser-button'],
            'text-primary',
            'bg-blue-gray-200',
          )}
          disabled={props.disabled}
          onClick={() => props.openFileSelector()}
        >
          Browse
        </Button>
      )}
    </div>
  );
}
